import React from 'react';
import Select from 'react-select';

import useEventTracking from '@hooks/useEventTracking';
import { ClickTarget, TrackingLocation, click } from '@tracking';
import { REACT_SELECT_STYLES } from '@utils/constants';

import { PERIOD_OPTIONS, PeriodOption, ReadershipMetricsStat } from '../types';
import Statistics from './Statistics';

interface ReadershipMetricsProps {
  reads: {
    oneMonth: ReadershipMetricsStat;
    fourMonths: ReadershipMetricsStat;
  };
  selectedPeriod: PeriodOption;
  setSelectedPeriod: (selectedOption: PeriodOption) => void;
}

const ReadershipMetrics = ({
  reads,
  selectedPeriod,
  setSelectedPeriod,
}: ReadershipMetricsProps) => {
  const { trackEvent } = useEventTracking({
    location: TrackingLocation.Analytics,
  });

  const handlePeriodChange = (selectedOption: PeriodOption) => {
    setSelectedPeriod(selectedOption);
    trackEvent(
      click({
        clickTarget: ClickTarget.DropDown,
        clickText: selectedOption.label,
      })
    );
  };
  const { articlesRead, newslettersRead } = reads[selectedPeriod.value];

  if (articlesRead.value === 0 && newslettersRead.value === 0) {
    return null;
  }

  return (
    <section className="mt-28 border-0 border-t border-solid border-t-grayscale-beige pt-28">
      <div className="flex flex-col gap-12 sm:flex-row sm:items-end sm:justify-between sm:gap-0">
        <h3 className="m-0 font-suisse-intl text-overline-md font-normal text-black">
          Readership metrics
        </h3>
        <div className="flex items-center gap-8">
          <span className="font-suisse-intl-mono text-overline-sm text-grayscale-gray">
            Period:
          </span>
          <Select
            unstyled
            styles={REACT_SELECT_STYLES}
            className="w-[180px]"
            options={PERIOD_OPTIONS}
            value={selectedPeriod}
            onChange={handlePeriodChange}
            isClearable={false}
            isSearchable={false}
            isDisabled={false}
          />
        </div>
      </div>
      <div className="mt-28 flex items-stretch gap-20">
        <Statistics {...articlesRead} />
        <Statistics {...newslettersRead} />
      </div>
    </section>
  );
};

export default ReadershipMetrics;
